import { CcusFormHoc } from './FieldFormElementsCcusProvider';

/**
 * 拡張したフォームコンポーネント
 */
const FieldName = CcusFormHoc('FieldName');
const FieldPostalCode = CcusFormHoc('FieldPostalCode');
const FieldPrefecture = CcusFormHoc('FieldPrefecture');
const FieldAddressCommon = CcusFormHoc('FieldAddressCommon');
const FieldSelectCommon = CcusFormHoc('FieldSelectCommon');
const FieldInputCommon = CcusFormHoc('FieldInputCommon');
const OfficePostalCode = CcusFormHoc('OfficePostalCode');
const OfficeTell = CcusFormHoc('OfficeTell');
const GroundBreakingDate = CcusFormHoc('GroundBreakingDate');
const CompleteScheduleDate = CcusFormHoc('CompleteScheduleDate');
const BuildeeStartScheduleDate = CcusFormHoc('BuildeeStartScheduleDate');
const BuildeeEndScheduleDate = CcusFormHoc('BuildeeEndScheduleDate');
export {
  FieldName,
  FieldPostalCode,
  FieldPrefecture,
  FieldAddressCommon,
  FieldSelectCommon,
  FieldInputCommon,
  OfficePostalCode,
  OfficeTell,
  GroundBreakingDate,
  CompleteScheduleDate,
  BuildeeStartScheduleDate,
  BuildeeEndScheduleDate,
};



// WEBPACK FOOTER //
// ./src/components/FieldFormElementsCcus.jsx